import { LOGGED_IN_CARDS_PER_PAGE } from '@/config';
import { useQuery } from '@apollo/client';
import { MANAGED_COMPANIES_QUERY } from '@/graphql/queries';
import { Maybe } from '@/types/graphql-types';

const useManagedCompanies = ({ first = LOGGED_IN_CARDS_PER_PAGE } = {}) => {
  const variables = { first };
  const { fetchMore, error, ...rest } = useQuery(MANAGED_COMPANIES_QUERY, {
    variables,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  const pagination = async (endCursor: Maybe<string>) =>
    await fetchMore({
      variables: {
        first,
        after: endCursor,
      },
    });

  return {
    pagination,
    error,
    ...rest,
  };
};

export { useManagedCompanies };
